// @ts-ignore App isn't typed yet
import App from './App';
import { enableMapSet } from 'immer';
import { enableTransmute } from 'immutable-less';
enableMapSet();
enableTransmute();
new App().start();